// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".vidjet-redirect-link[data-v-221ef700]{height:50px;background:rgba(88,88,88,.8);border-radius:5px;display:flex;flex-direction:column;position:absolute;bottom:-20px;z-index:-1}.isTopLeft.vidjet-redirect-link[data-v-221ef700]{z-index:25;top:16px;left:12px;height:-moz-fit-content;height:fit-content}.isBubbleLeft.vidjet-redirect-link[data-v-221ef700]{right:0}.vidjet-logo[data-v-221ef700]{height:10px;width:100px;cursor:pointer;margin-top:auto;padding:5px 10px}", ""]);
// Exports
module.exports = exports;
